var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"mr-1 subscription-lock-icon",attrs:{"color":_vm.color ? _vm.color: undefined},on:{"click":function($event){$event.stopPropagation();}}},on),[_vm._v("mdi-lock ")])]}}])},[_c('div',[_vm._v("Nicht verfügbar")])])}
var staticRenderFns = []

export { render, staticRenderFns }